import React from 'react';
import {
  Container,
  Grid,
  Divider,
  Header,
  Image,
  List,
} from 'semantic-ui-react';
import Routes from 'config/routes';
import { Link } from 'react-router-dom';
import BirdColoredLogoImg from '../../images/logo/bird-colored.svg';
import paymentMethodsFooter from '../../images/payment-methods-final.png';
import paymentMethodsFooterSA from '../../images/payment_methods_footer_sa.png';
import hotLine from '../../images/hotline_footer.png';

import { compose } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './messages';

// eslint-disable-next-line react/prefer-stateless-function
class Footer extends React.Component {
  render() {
    const countryCode = this.props.currentUser.country
      ? this.props.currentUser.country.iso_code
      : this.props.geo.countryCode;
    const { pathname } = this.props.location;
    const LYNKS_EXPORT_PATH = pathname === '/export';
    return (
      <div
        style={{
          background:
            'Linear-gradient(-90deg, rgba(0, 0, 0, 0.7) 0%,rgba(0, 0, 0, 0.7) 100%), Linear-gradient(-90deg, #00c8f5 0%,#717bdb 100%)',
          padding: '2em 0em',
        }}
      >
        <Container>
          <Grid inverted padded stackable>
            {countryCode === 'EG' ? (
              <Grid.Row>
                <Grid.Column width={4} textAlign="center"></Grid.Column>
                {!LYNKS_EXPORT_PATH && (
                  <Grid.Column width={2} verticalAlign="middle">
                    <Header style={{ display: 'inline-block' }} inverted>
                      <FormattedMessage {...messages.payHeader} />
                    </Header>
                  </Grid.Column>
                )}
                {!LYNKS_EXPORT_PATH && (
                  <Grid.Column width={8} className="textLeft">
                    <Image inline src={paymentMethodsFooter} />
                  </Grid.Column>
                )}
                <Grid.Column
                  width={2}
                  className={LYNKS_EXPORT_PATH ? 'textStart' : 'textRight'}
                >
                  <Image inline src={hotLine} />
                </Grid.Column>
              </Grid.Row>
            ) : (
              <div></div>
            )}
            {/* this  */}
            {countryCode === 'SA' && !LYNKS_EXPORT_PATH ? (
              <Grid.Row>
                <Grid.Column width={4} textAlign="center"></Grid.Column>
                <Grid.Column width={2} verticalAlign="middle">
                  <Header style={{ display: 'inline-block' }} inverted>
                    <FormattedMessage {...messages.payHeader} />
                  </Header>
                </Grid.Column>
                <Grid.Column width={8} className="textLeft">
                  <Image inline src={paymentMethodsFooterSA} />
                </Grid.Column>
              </Grid.Row>
            ) : (
              <div></div>
            )}

            <Grid.Row columns="equal">
              <Grid.Column textAlign="center" verticalAlign="middle">
                <Image src={BirdColoredLogoImg} size="tiny" centered />
              </Grid.Column>

              <Grid.Column>
                <Header inverted>
                  <FormattedMessage {...messages.aboutHeader} />
                </Header>
                <List link inverted>
                  <List.Item as={Link} to={Routes.Stores}>
                    <FormattedMessage {...messages.storesLink} />
                  </List.Item>

                  <List.Item as={Link} to={Routes.CashbackPage}>
                    <FormattedMessage {...messages.CashbackLink} />
                  </List.Item>

                  <List.Item as={Link} to={Routes.FindTheLink}>
                    <FormattedMessage {...messages.findTheLink} />
                  </List.Item>

                  {countryCode === 'EG' && (
                    <List.Item as={Link} to={Routes.Business}>
                      <FormattedMessage {...messages.BusinessLink} />
                    </List.Item>
                  )}

                  {countryCode === 'EG' && (
                    <List.Item as={Link} to={Routes.LynksVsEdfa3ly}>
                      <FormattedMessage {...messages.LynksVsEdfa3lyLink} />
                    </List.Item>
                  )}
                </List>
                {countryCode === 'EG' && (
                  <List link inverted>
                    <List.Item
                      href="https://www.google.com/maps/dir//31.208813,29.934398/@31.208813,29.934398,17z"
                      target="_blank"
                    >
                      <List.Content>
                        <FormattedMessage {...messages.address} />
                      </List.Content>
                    </List.Item>
                  </List>
                )}
              </Grid.Column>

              <Grid.Column>
                <Header inverted>
                  <FormattedMessage {...messages.helpHeader} />
                </Header>
                <List link inverted>
                  <List.Item as={Link} to={Routes.HowItWorks}>
                    <FormattedMessage {...messages.howLink} />
                  </List.Item>
                  <List.Item as={Link} to={Routes.ProhibitedItems}>
                    {countryCode === 'SA' ? (
                      <FormattedMessage {...messages.prohibitedLinkKSA} />
                    ) : (
                      <FormattedMessage {...messages.prohibitedLink} />
                    )}
                  </List.Item>
                  <List.Item as={Link} to={Routes.TermsAndConditions}>
                    <FormattedMessage {...messages.termsLink} />
                  </List.Item>
                  <List.Item as={Link} to={Routes.PrivacyPolicy}>
                    <FormattedMessage {...messages.privacyPolicyLink} />
                  </List.Item>
                  <List.Item as={Link} to={Routes.Faq}>
                    <FormattedMessage {...messages.faqLink} />
                  </List.Item>
                </List>
              </Grid.Column>

              <Grid.Column>
                <Header inverted>
                  <FormattedMessage {...messages.contactHeader} />
                </Header>
                <List link inverted>
                  {countryCode === 'EG' && (
                    <List.Item>
                      <List.Icon name="call" />
                      <List.Content>
                        <FormattedMessage {...messages.hotNo} />
                      </List.Content>
                    </List.Item>
                  )}
                  <List.Item
                    as="a"
                    href="https://wa.me/201010616061"
                    target="_blank"
                  >
                    <List.Icon name="whatsapp" />
                    <List.Content>01010616061</List.Content>
                  </List.Item>
                  <List.Item as={Link} to={Routes.Contact}>
                    <List.Icon name="send outline" />
                    <List.Content>
                      <FormattedMessage {...messages.contactLink} />
                    </List.Content>
                  </List.Item>
                  <List.Item as="a" href="mailto:support@lynks.com">
                    <List.Icon name="mail outline" />
                    <List.Content>
                      <FormattedMessage {...messages.mailLink} />
                    </List.Content>
                  </List.Item>
                  <List.Item
                    as="a"
                    href="https://m.me/lynksglobal"
                    target="_blank"
                  >
                    <List.Icon name="comments outline" />
                    <List.Content>
                      <FormattedMessage {...messages.fbLink} />
                    </List.Content>
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
            <Divider hidden />
            <Grid.Row
              style={{
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Header size="tiny" inverted style={{ marginBottom: 0 }}>
                <FormattedMessage
                  {...messages.copyRight}
                  values={{
                    year: new Date().getFullYear(),
                  }}
                />
              </Header>
              <Header size="tiny" inverted style={{ marginTop: 0 }}>
                <Image
                  spaced="right"
                  size="mini"
                  src={
                    'https://www.exohub.com/static/media/logoIcon.69f61e92.svg'
                  }
                />
                <FormattedMessage {...messages.exohubPowered} />
              </Header>
            </Grid.Row>
          </Grid>
        </Container>
      </div>
    );
  }
}
export default compose(injectIntl)(Footer);



// WEBPACK FOOTER //
// ./app/components/Footer/index.js